import React from "react";
import { useMyTimesheetAppbarBadge } from "./use-appbar-badge";
import { OcAppBarBadge } from "oc/components";

export const MyTimesheetAppbarBadge: React.FC = () => {
  const { handleClick, count } = useMyTimesheetAppbarBadge();
  if (count === 0) return null;

  return (
    <OcAppBarBadge
      icon="mdi:timer"
      value={count}
      onClick={handleClick}
      id="my-time-sheet-header-badge-icon"
      badgeId="my-time-sheet-header-badge-count"
    />
  );
};
